/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetUserQuestStatsResponsePagination } from './GetUserQuestStatsResponsePagination';
import {
    GetUserQuestStatsResponsePaginationFromJSON,
    GetUserQuestStatsResponsePaginationFromJSONTyped,
    GetUserQuestStatsResponsePaginationToJSON,
    GetUserQuestStatsResponsePaginationToJSONTyped,
} from './GetUserQuestStatsResponsePagination';

/**
 * 
 * @export
 * @interface GetUserQuestStatsResponse
 */
export interface GetUserQuestStatsResponse {
    /**
     * 
     * @type {string}
     * @memberof GetUserQuestStatsResponse
     */
    message?: string;
    /**
     * Array of user stats with fully populated reward data including milestone rewardConfigs
     * @type {Array<object>}
     * @memberof GetUserQuestStatsResponse
     */
    userStats?: Array<object>;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetUserQuestStatsResponse
     */
    uniqueGameIds?: Array<string>;
    /**
     * Weekly XP cap for time-played rewards, sourced from the
     * platform-wide PLAYTIME OWReward record's `rewardMax`. Omitted
     * when no PLAYTIME reward record exists. Frontends should NOT
     * default this to 0 — render the count without a denominator
     * when the field is absent.
     * 
     * @type {number}
     * @memberof GetUserQuestStatsResponse
     */
    timeRewardWeeklyMax?: number;
    /**
     * 
     * @type {GetUserQuestStatsResponsePagination}
     * @memberof GetUserQuestStatsResponse
     */
    pagination?: GetUserQuestStatsResponsePagination;
}

/**
 * Check if a given object implements the GetUserQuestStatsResponse interface.
 */
export function instanceOfGetUserQuestStatsResponse(value: object): value is GetUserQuestStatsResponse {
    return true;
}

export function GetUserQuestStatsResponseFromJSON(json: any): GetUserQuestStatsResponse {
    return GetUserQuestStatsResponseFromJSONTyped(json, false);
}

export function GetUserQuestStatsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetUserQuestStatsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'message': json['message'] == null ? undefined : json['message'],
        'userStats': json['userStats'] == null ? undefined : json['userStats'],
        'uniqueGameIds': json['uniqueGameIds'] == null ? undefined : json['uniqueGameIds'],
        'timeRewardWeeklyMax': json['timeRewardWeeklyMax'] == null ? undefined : json['timeRewardWeeklyMax'],
        'pagination': json['pagination'] == null ? undefined : GetUserQuestStatsResponsePaginationFromJSON(json['pagination']),
    };
}

export function GetUserQuestStatsResponseToJSON(json: any): GetUserQuestStatsResponse {
    return GetUserQuestStatsResponseToJSONTyped(json, false);
}

export function GetUserQuestStatsResponseToJSONTyped(value?: GetUserQuestStatsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'message': value['message'],
        'userStats': value['userStats'],
        'uniqueGameIds': value['uniqueGameIds'],
        'timeRewardWeeklyMax': value['timeRewardWeeklyMax'],
        'pagination': GetUserQuestStatsResponsePaginationToJSON(value['pagination']),
    };
}

